import { BASE_URL } from '../../../Constant';

export const API_GET_DOCUMENT_STATS: string = `${BASE_URL}/document/stats`;
export const API_GET_DOCUMENT_MONTHLY_STATS: string = `${BASE_URL}/document/monthly-stats`;
export const API_GET_FILLED_DOCUMENT_STATS: string = `${BASE_URL}/document/filled-stats`;
export const API_GET_FILLED_DOCUMENT_MONTHLY_STATS: string = `${BASE_URL}/document/filled-monthly-stats`;
export const API_GET_TEMPLATE_DOCUMENT_STATS: string = `${BASE_URL}/document/template-stats`;
export const API_GET_TEMPLATE_DOCUMENT_MONTHLY_STATS: string = `${BASE_URL}/document/template-monthly-stats`;
export const API_GET_PAYMENT_STATS: string = `${BASE_URL}/payment/stats`;
export const API_GET_PAYMENT_MONTHLY_STATS: string = `${BASE_URL}/payment/monthly-stats`;
export const API_GET_USER_STATS: string = `${BASE_URL}/user/stats`;
export const API_GET_USER_MONTHLY_STATS: string = `${BASE_URL}/user/monthly-stats`;
